import React from "react";
import "./WitEarnHome.scss"
import { sortByOrderAscending } from "../../helper/helper";
import WitEarnHomeHero from "./WitEarnHomeHero";
import WitEarnHomeFeatures from "./WitEarnHomeFeatures";
import WitEarnHomeSolutions from "./WitEarnHomeSolutions";
import WitEarnHomeResources from "./WitEarnHomeResources";
import WitEarnHomePricing from "./WitEarnHomePricing";
import WitEarnHomeInsights from "./WitEarnHomeInsights";
import WitEarnHomeFinance from "./WitEarnHomeFinance";
import WitEarnHomeReviews from "./WitEarnHomeReviews";
import { useSelector } from "react-redux";
const WitEarnHome = () => {
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "home")
    const Components = page?.Components || []

    const getComponents = (component) => {
        switch (component.ID) {
            case "WitEarnHomeHero":
                return <WitEarnHomeHero components={component.Components} />
            case "WitEarnHomeFeatures":
                return <WitEarnHomeFeatures components={component.Components} />
            case "WitEarnHomeSolutions":
                return <WitEarnHomeSolutions components={component.Components} />
            case "WitEarnHomeResources":
                return <WitEarnHomeResources components={component.Components} />
            case "WitEarnHomePricing":
                return <WitEarnHomePricing components={component.Components} defaultPlan={component.Props.defaultPlan} />
            case "WitEarnHomeInsights":
                return <WitEarnHomeInsights components={component.Components} />
            case "WitEarnHomeFinance":
                return <WitEarnHomeFinance components={component.Components} />
            case "WitEarnHomeReviews":
                return <WitEarnHomeReviews components={component.Components} />
            default:
                return <div />
        }

    }
    return (
        <div className="WitEarnHome">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )

}
export default WitEarnHome